import { utf8Encode } from '@angular/compiler/src/util';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, DoCheck } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GlobalsService } from '../../services/globals.service';
import { StorageService } from '../../services/storage.service';
import { ViasConnectionService } from '../../services/vias-connection.service';
import { ButtonBarItem } from '../buttonbar/buttonbar.component';
import { CellChangeEvent, DataGridColumn, DataGridEvent, DGButtons, StatusBarSummaryData } from '../datagrid/datagrid.component';
import { FormItem } from '../form/FormItem';

// tslint:disable-next-line: no-conflicting-lifecycle
@Component({
  selector: 'vias-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, OnChanges, DoCheck {
  @Input() item: FormItem;
  @Input() form: FormGroup;
  @Output() cellChange: EventEmitter<CellChangeEvent> = new EventEmitter<CellChangeEvent>();
  @Output() dgChange: EventEmitter<object[]> = new EventEmitter<object[]>();
  @Output() rowClick: EventEmitter<DataGridEvent> = new EventEmitter<DataGridEvent>();
  @Output() dblClick: EventEmitter<DataGridEvent> = new EventEmitter<DataGridEvent>();
  @Output() selectChange: EventEmitter<DataGridEvent> = new EventEmitter<DataGridEvent>();
  @Output() addClick: EventEmitter<DataGridEvent> = new EventEmitter<DataGridEvent>();
  @Output() editClick: EventEmitter<DataGridEvent> = new EventEmitter<DataGridEvent>();
  @Output() deleteClick: EventEmitter<DataGridEvent> = new EventEmitter<DataGridEvent>();
  numLocale: string;
  dcolumns: DataGridColumn[];
  statusBarItems: StatusBarSummaryData[];
  dataSource: object[] = [];
  datagridOptions: {} = {};
  dgWidth: string = '100%';
  dgHeight: string = '300px';
  tableSelectedItem: DataGridEvent;
  tableSelectedItems: any;
  dgButtons: DGButtons = {
    hasAddBtn: false, hasEditBtn: false, hasDeleteBtn: false,
    addBtnText: 'add', editBtnText: 'edit', deleteBtnText: 'delete'
  };

  constructor(
    protected globals: GlobalsService,
    protected viasService: ViasConnectionService,
    protected storage: StorageService,
    protected next: ActivatedRoute,
    protected route: Router,
    protected translate: TranslateService,
    protected dialog: MatDialog
  ) {
    translate.use(globals.langLocale.substr(0, 2));
  }

  ngOnInit(): void {
    if (this.item.hasMultiSelectTable === undefined) {
      this.item.hasMultiSelectTable = false;
    }
    this.datagridOptions['multipleRowSelection'] = this.item.hasMultiSelectTable;
    this.datagridOptions['hasSelectButton'] = false;
    this.datagridOptions['hasSelectButton'] = false;
    this.datagridOptions['isLocalRefresh'] = true;
    this.datagridOptions['sidebarVisible'] = false;
    if (this.item.tableOptions !== undefined) {
      for (const x in this.item.tableOptions) {
        this.datagridOptions[x] = this.item.tableOptions[x];
      }
    }
    if (this.item.tableStatusBarItems !== undefined) {
      this.statusBarItems = this.item.tableStatusBarItems;
    }
    if (this.item.width !== undefined) {
      this.dgWidth = this.item.width;
    }

    if (this.item.height !== undefined) {
      this.dgHeight = this.item.height;
    }

    if (this.item.disabled !== undefined) {
      if (this.item.disabled) {
        this.datagridOptions['functionsReadOnly'] = true;
      }
    }

    if (this.item.tableDGButtons !== undefined) {
      for (const x in this.item.tableDGButtons) {
        this.dgButtons[x] = this.item.tableDGButtons[x];
      }
    }


    this.dcolumns = this.item.tableColumns;
    // this.dataSource = this.item.tableDataSource;
    this.numLocale = this.globals.numLocale;
    // this.translateDGCols(this.columns);
  }
  ngOnChanges(): void {
    if (this.item !== undefined) {
      if (this.item.tableColumns !== undefined) {
        this.dcolumns = this.item.tableColumns;
      }
    }
  }
  ngDoCheck(): void {
    if (this.item !== undefined) {
      if (this.item.tableDGButtons !== undefined) {
        for (const x in this.item.tableDGButtons) {
          this.dgButtons[x] = this.item.tableDGButtons[x];
        }
      }
      if (this.item.tableOptions !== undefined) {
        for (const x in this.item.tableOptions) {
          this.datagridOptions[x] = this.item.tableOptions[x];
        }
      }
    }
  }
  butonclickHandler(event: ButtonBarItem): void {
    if (this.tableSelectedItems !== undefined) {
      if (this.tableSelectedItems.length > 1) {
        this.tableSelectedItem['items'] = this.tableSelectedItems;
      } else {
        delete this.tableSelectedItem['items'];
        this.tableSelectedItem['item'] = this.tableSelectedItems[0];
      }
    }
    if (event.onClick) {
      event.onClick(event, this.item, this.tableSelectedItem,
        this.route, this.translate, this.storage, this.globals, this.viasService, this.dialog);
    }
  }
  tableCellChange($event): void {
    this.cellChange.emit($event);
    this.dgChange.emit(this.item.tableDataSource);
  }
  tableClickHandler($event): void {
    this.tableSelectedItem = $event;
    this.rowClick.emit($event);
  }
  tableDoubleClicked($event): void {
    this.dblClick.emit($event);
  }
  tableSelectBtnClickHandler($event): void {
    this.rowClick.emit($event);
  }
  tableSelectChangeHandler(event): void {
    if (event.selectedItems !== undefined) {
      this.tableSelectedItems = event.selectedItems;
    }
    this.selectChange.emit(event);
  }
  tableAddBtnClickHandler($event): void {
    this.addClick.emit($event);
  }
  tableEditBtnClickHandler($event): void {
    this.editClick.emit($event);
  }
  tableDeleteBtnClickHandler($event): void {
    if (this.tableSelectedItems !== undefined) {
      if (this.tableSelectedItems.length > 1) {
        $event['items'] = this.tableSelectedItems;
      }
    }
    this.deleteClick.emit($event);
  }
}
